// extracted by mini-css-extract-plugin
export var standaloneTable = "_e6-0";
export var standaloneTableWithBodyFill = "_e6-1";
export var withExtraHeader = "_e6-2";